"use client";

import React, { useEffect } from "react";

import MobileContainer from "./MobileContainer";
import DesktopContainer from "./DesktopContainer";
import { useLocale } from "next-intl";

function SidebarMobileScreen({ children }: SidebarPropsType) {
  const locale = useLocale();
 
  return (
    <>
      <div className="lg:hidden">
        <MobileContainer />
      </div>
      <div className="hidden lg:block ">
        <DesktopContainer />
      </div>
    </>
  );
}
export default SidebarMobileScreen;

export type SidebarPropsType = {
  children?: JSX.Element;
};
